import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './app-confirm-dialog.html',
})
export class AppConfirmDialog {
  @Input() visible = false;
  @Input() type : 'confirmation' | 'question' | 'logout' | 'alert' | 'delete' = 'confirmation';
  @Input() title = '¿Estás seguro?';
  @Input() message = 'Esta acción no se puede deshacer.';
  @Input() confirmLabel = 'Confirmar';
  @Input() cancelLabel = 'Cancelar';

  // Nuevas propiedades para mayor flexibilidad
  @Input() icon?: string;
  @Input() loading = false;
  @Input() confirmText?: string;
  @Input() cancelText?: string;

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  @Output() visibleChange = new EventEmitter<boolean>();

  onConfirm(): void {
    this.confirm.emit();
  }

  onCancel(): void {
    this.visibleChange.emit(false);
    this.cancel.emit();
  }

  onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.onCancel();
    }
  }
}
